var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('recent-bookings',{class:_vm.classes}),_c('wallet',{class:_vm.classes}),_c('balance',{class:_vm.classes}),_c('rib',{attrs:{"client":_vm.client,"classes":_vm.classes}}),_c('notes',{class:_vm.classes})],1)}
var staticRenderFns = []

export { render, staticRenderFns }